// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"a65ed70e","55":"17daf6ee","466":"3e6d8494","599":"6ae7527c","624":"7bc0d421","780":"7e050d4e"}[chunkId] + ".chunk.js";
};